var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('StripBanner',{attrs:{"btn-text":"Scopri come","link":"/valuta-casa"}},[_vm._v("\n      Vuoi valutare la tua casa in modo semplice, veloce, affidabile?\n    ")])],1),_vm._v(" "),_c('section',{staticClass:"pt-16 pb-20 md:pt-20 md:pb-20"},[_c('div',{staticClass:"container"},[_c('SellMetalinks')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }